import { Copy, Download, Trash2, Info } from 'lucide-react';
import { Button } from './Button';
import { useState } from 'react';
import InfoModal from './InfoModal';

/**
 * Application Header Component
 */
export function Header({ 
  onCopy,
  onDownload, 
  onClear,
  hasContent,
  fileInputRef,
  onFileChange 
}) {
  const [infoOpen, setInfoOpen] = useState(false);
  return (
    <header className="sticky top-0 z-10 bg-white/95 backdrop-blur-sm border-b border-slate-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between gap-4">
          <img
            src="/logo.png"
            alt="Logo"
            className="h-10 w-auto"
          />
          <div className="flex gap-2">
            <button
              type="button"
              onClick={() => setInfoOpen(true)}
              title="How to use"
              className="p-2 rounded-md border border-slate-200 text-slate-700 bg-white hover:bg-slate-50 shadow-sm"
            >
              <Info className="w-5 h-5" />
            </button>
            <input 
              ref={fileInputRef} 
              type="file" 
              accept="application/json,.json" 
              className="hidden" 
              onChange={onFileChange} 
            />
            {hasContent && (
              <>
                <Button 
                  onClick={onClear}
                  variant="secondary"
                  icon={Trash2}
                  className="hidden sm:inline-flex"
                >
                  Clear
                </Button>
                <Button 
                  onClick={onCopy} 
                  variant="secondary"
                  icon={Copy}
                >
                  Copy
                </Button>
                <Button 
                  onClick={onDownload} 
                  variant="primary"
                  icon={Download}
                >
                  Download
                </Button>
              </>
            )}
          </div>
        </div>
      </div>
      <InfoModal open={infoOpen} onClose={() => setInfoOpen(false)} />
    </header>
  );
}
